
const urlPrefixList ={
    host:process.env.REACT_APP_DEV_BASE_URL,
    api:'wp-json/wp/v2/',
    categoriesPath:'categories',
    tagsPath:'tags',
    acfApi:'wp-json/acf/v2/',
    authApi:'?rest_route=/swd/v1/',
    pmtApi:'wp-json/sw/v1/',
    passwordApi:'wp-json/bdpwr/v1/',
    passwordReqPath:'reset-password',
    passwordSetPath:'set-password',
    pmtCreatePath:'pmtjs/create',
    pmtUpdatePath:'pmtjs/update',
    pmtConfirmPath:'pmtjs/confirm',
    customApi:'wp-json/sw_custom_routes/v1/',
    balancePath:'user_balance',
    creditPath:'credit',        
    usersPath:'users',
    mediaPath:'media',
    rssFeedsPath:'sw_feed',
    rssFeedTaxPath:'source',
    postsPath:'posts',
    randomPostsPath:'random-posts',
    accountPath:'account',
    donationsPath:'donation',
    userDonationsPath:'user_donations',
    userCreditsPath:'user_credits',
    fundraiserPath:'fundraiser',
    orgsPath:'organisationpage',
    orgsListPath:'organisation',
    orgCustomPath:'custom_orgpages',
    orgWhereAdminPath:'organisations_where_admin',
    acfPath:'options/',
    authPath:'auth/',
    resetTokenPath:'auth/refresh',
    signInPath:'autologin',
    registerPath:'users',
    psResetCodePath:'users/reset_password',
    fundraiserProgressPath:'fundraiser_progress',
    fundraiserFilteredPath:'filtered_fundraisers',
}

/**Set Url prefix for dev */
if (process.env.NODE_ENV === 'production') {
    urlPrefixList.host='/';
  }
/**
* Build the necessary urls for api calls
* @param name name of the url
* @param arg1 first argument to pass to the url
* @param arg2 second argument to pass to the url
* @returns a url string to use in the api call
* Note, solution for things like jwt to be defined
*/
 const Urls = (name:any, arg1?: string, arg2?: string)=> {

    /**Store url construction functions */
    const UrlHandlers:any = {};
    
    /**Function to build userCreditUrl */
    UrlHandlers.userCreditUrl = () => {
        let userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.creditPath}?author=${userId}&acf_format=standard&?per_page=100`;
    }
    /**Create fetch user feed source url */
    UrlHandlers.rssFeedsUrl = () => {
        const sources=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.rssFeedsPath}?${sources}&_embed&per_page=40`;
    }
    UrlHandlers.allFeeds = () => {
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.rssFeedsPath}?_embed&_fields&per_page=40`;
    }
    UrlHandlers.byTaxonomyFeedsUrl = () => {
        const source=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.rssFeedsPath}?_embed&_fields&categories=${source}`;
    }

    UrlHandlers.singleFeedUrl = () => {
        const itemId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.rssFeedsPath}/${itemId}?_embed&_fields`;
    }
    UrlHandlers.feedTaxonomyUrl=()=>{
        const itemId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.rssFeedTaxPath}/${itemId}?_embed&_fields`;
    }
    UrlHandlers.allNews = () => {
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.postsPath}?_embed&_fields&per_page=40`;
    }
    UrlHandlers.byTaxonomyNewsUrl = () => {
        const source=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.postsPath}?_embed&_fields&categories=${source}`;
    }

    UrlHandlers.singleNewsUrl = () => {
        const itemId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.postsPath}/${itemId}?_embed&_fields`;
    }
    UrlHandlers.NewsTaxonomyUrl=()=>{
        const itemId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.postsPath}/${itemId}?_embed&_fields`;
    }

    UrlHandlers.organizationUrl = () => {
        let categories='';
        let order='orderby=title';
        if(arg1?.length!>0){
            categories=`categories=${arg1}`
        }
 
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.orgsPath}?_embed&acf_format=standard&${order}&order=asc&per_page=99&${categories}`;
    }
    UrlHandlers.organizationSingleUrl = () => {
        const orgId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.orgsPath}/${orgId}?_embed&acf_format=standard`;
    }
    UrlHandlers.organizationListUrl = () => {
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.orgsListPath}?orderby=title&order=asc&per_page=100`;
    }
    /** */
    UrlHandlers.donationsUrl = () => {
        const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.donationsPath}?author=${userId}&acf_format=standard&orderby=date&order=desc&per_page=100`;
    }
    UrlHandlers.userDonationsUrl = () => {
        const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.customApi}${urlPrefixList.userDonationsPath}?per_page="100"&id=${userId}&orderby=date&order=desc`;
    }
    UrlHandlers.userCreditsUrl = () => {
        const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.customApi}${urlPrefixList.userCreditsPath}?per_page="100"&id=${userId}&orderby=date&order=desc`;
    }
    UrlHandlers.createDonationUrl = () => {
        //const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.donationsPath}`;
    }
    UrlHandlers.updateDonationUrl = () => {
        //const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.donationsPath}/${arg1}`;
    }
    /** */
    UrlHandlers.createCreditUrl = () => {
        //const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.creditPath}`;
    }
    UrlHandlers.updateCreditUrl = () => {
        //const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.creditPath}/${arg1}`;
    }
    /** */
    UrlHandlers.userfundraiserUrl = () => {
        const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.fundraiserPath}?author=${userId}&acf_format=standard&orderby=title&order=asc&per_page=100`;
    }
    UrlHandlers.allFundraiserUrl = () => {
        return `${urlPrefixList.host}${urlPrefixList.customApi}${urlPrefixList.fundraiserFilteredPath}`;
    }
    UrlHandlers.singleFundraiserUrl = () => {
        const itemId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.fundraiserPath}/${itemId}`;
    }
    UrlHandlers.createFundraiserUrl = () => {
        //const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.fundraiserPath}`;
    }
    UrlHandlers.updatFundraiserUrl = () => {
        //const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.fundraiserPath}/${arg1}`;
    }
    /** */
    UrlHandlers.createMediaUrl = () => {
        //const userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.mediaPath}`;
    }
    /** */
    UrlHandlers.optionsUrl = () => {
        return `${urlPrefixList.host}${urlPrefixList.acfApi}${urlPrefixList.acfPath}`;

    }
    UrlHandlers.authenticateUserUrl = () => {
        return `${urlPrefixList.host}${urlPrefixList.authApi}${urlPrefixList.authPath}`;

    }
    UrlHandlers.signInUserUrl = () => {
        return `${urlPrefixList.host}${urlPrefixList.authApi}${urlPrefixList.signInPath}`;

    }
    UrlHandlers.registerUser = () => {
        return `${urlPrefixList.host}${urlPrefixList.authApi}${urlPrefixList.registerPath}`;

    }
    UrlHandlers.updateUserUrl = () => {
       let  userId=arg1;
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.usersPath}/${userId}`;
    }

    UrlHandlers.getUser = () => {
        let userid=arg1
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.usersPath}/${userid}`;

    }
    UrlHandlers.getPaymentInterface=()=>{
        return `${urlPrefixList.host}${urlPrefixList.pmtApi}${urlPrefixList.pmtCreatePath}`;

    }
    UrlHandlers.updatePayment=()=>{
        return `${urlPrefixList.host}${urlPrefixList.pmtApi}${urlPrefixList.pmtUpdatePath}`;

    }
    UrlHandlers.confirmPayment=()=>{
        return `${urlPrefixList.host}${urlPrefixList.pmtApi}${urlPrefixList.pmtConfirmPath}`;

    }
    UrlHandlers.psRestCodeUrl=()=>{
        return `${urlPrefixList.host}${urlPrefixList.passwordApi}${urlPrefixList.passwordReqPath}`;

    }
    UrlHandlers.resetPsUrl=()=>{
        return `${urlPrefixList.host}${urlPrefixList.passwordApi}${urlPrefixList.passwordSetPath}`;

    }
    UrlHandlers.resetTokenUrl=()=>{
        return `${urlPrefixList.host}${urlPrefixList.authApi}${urlPrefixList.resetTokenPath}`;

    }
    UrlHandlers.userBalanceUrl = () => {
        return `${urlPrefixList.host}${urlPrefixList.customApi}${urlPrefixList.balancePath}`;

    }
    UrlHandlers.randomPosts = () => {
        let posttype=arg1;
        let count=arg2;
        return `${urlPrefixList.host}${urlPrefixList.customApi}${urlPrefixList.randomPostsPath}?posttype=${posttype}&count=${count}`;

    }
    UrlHandlers.fundraiserProgressUrl = () => {
        return `${urlPrefixList.host}${urlPrefixList.customApi}${urlPrefixList.fundraiserProgressPath}`;

    }
    UrlHandlers.listCategories = () => {
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.categoriesPath}?acf_format=standard&per_page=100`;

    }
    UrlHandlers.listCategoriesIn = () => {
        let categories='';
        if(arg1?.length!>0){
            categories=`include=${arg1}`
        }
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.categoriesPath}?acf_format=standard${categories}&per_page=100`;

    }
    UrlHandlers.listTags = () => {
        return `${urlPrefixList.host}${urlPrefixList.api}${urlPrefixList.tagsPath}?per_page=100`;

    }
    
    UrlHandlers.orgsWhereAdmin=()=>{
        let id=arg1;
        return `${urlPrefixList.host}${urlPrefixList.customApi}${urlPrefixList.orgWhereAdminPath}?id=${id}`;

    }
    UrlHandlers.orgsCustomUrl=()=>{
        let categories='';
        if(arg1?.length!>0){
            categories=`cats=${arg1}`
        }
        return `${urlPrefixList.host}${urlPrefixList.customApi}${urlPrefixList.orgCustomPath}?${categories}`;

    }

    return UrlHandlers[name]();


}

export default Urls;